import React, { Component } from 'react';

import Form from './components/Form';
import ListaCitas from './components/ListaCitas'

class App extends Component {
  state = {
    citas: []
  }

  agendarCita = nuevaCita => {
    // copiar state actual
    // copy the last state 
    const citas = [...this.state.citas, nuevaCita];
    // actualizar state
    // update state
    this.setState({
      citas
    })
  }
  
  componentDidMount() {
    // Cuando el DOM haya sido cargado, imprimir datos del LS
    // When DOM has been loaded, print data from LS
    let citasLS = localStorage.getItem("citas");
    if(citasLS){
      this.setState({
        citas: JSON.parse( citasLS )
      })
    }    
  }

  componentDidUpdate() {
    // por cada vez que se detecte cambios, actualizar LS
    // each moment the component change, update LS
    localStorage.setItem("citas", JSON.stringify(this.state.citas));
  }

  eliminarCita = id => {
    // obtener state
    // get state
    const citasActuales = [...this.state.citas];
    // eliminar cita
    // delete cita
    const citas = citasActuales.filter(cita => cita.id !== id);
    // actualizar state
    // update state
    console.log(citas)
    this.setState({
      citas
    })
    console.log("borrado");
  }

  render() {
    return (
      <div className="App pb-5">
          <h1 className="text-center text-white py-4">AgendApp</h1>
          <div className="bg-white py-5">        
              <div className="row p-3">
                <div className="col-md-6 pb-5">
                  <div className="card p-4 shadow">
                    <h2 className="text-center">Agendar Cita</h2>
                    <Form
                      agendarCita={this.agendarCita}
                    />
                  </div>
                </div>
                <div className="col-md-6 pb-2">
                  <div className="card p-1 shadow">
                    <h2 className="text-center">Citas</h2>
                    <ListaCitas 
                      citas={this.state.citas}
                      eliminarCita={this.eliminarCita}
                    />
                  </div>
                </div>
              </div>
          </div>
      </div>
    );
  }
}

export default App;
